type PeriodFields = {
  current_period_start?: number
  current_period_end?: number
}

type SubscriptionWithPeriods = PeriodFields & {
  items: { data: Array<PeriodFields & { price?: { id: string } }> }
}

type BillingPeriod = { start: number | null; end: number | null }

/**
 * The current billing period, read from the item carrying `priceId`, or the only item when
 * there is one, falling back to the subscription-level fields older Stripe API versions return.
 */
export const getBillingPeriod = (
  subscription: SubscriptionWithPeriods,
  priceId?: string | null
): BillingPeriod => {
  const items = subscription.items.data
  const item =
    items.find((entry) => entry.price?.id === priceId) ??
    (items.length === 1 ? items[0] : undefined)
  return {
    start:
      item?.current_period_start ?? subscription.current_period_start ?? null,
    end: item?.current_period_end ?? subscription.current_period_end ?? null,
  }
}
